import { DeleteOutlined, EyeOutlined } from '@ant-design/icons';
import { Button, Input, Modal } from 'antd';
import PropTypes from 'prop-types';
import React, { forwardRef, useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { Previewer } from '../components/design';
import { getPreview } from '../library/constants';
import styles from './addFile.module.scss';
const { TextArea } = Input


const AddFileUpload = forwardRef(function AddFileUpload(_, ref) {
    const [, setFiles] = useState([])
    const [reload, setReload] = useState()
    const [isModalOpen, setisOpen] = useState(false)
    useEffect(() => {
        if (!ref.current) {
            ref.current = []
        }
        // Make sure to revoke the data uris to avoid memory leaks, will run on unmount
        return () => ref.current.forEach(file => URL.revokeObjectURL(file.file.preview));
    }, [reload]);
    const { getRootProps, getInputProps } = useDropzone({
        multiple: true,
        maxSize: 10 * 1024 * 1024,
        maxFiles: 10,
        accept: {
            'image/jpg': ['.jpg'],
            'image/jpeg': ['.jpeg'],
            'image/png': ['.png'],
            'application/pdf': ['.pdf'],
            'image/tiff': ['.tiff', '.tif'],
            'image/svg+xml': ['.svg'],
            'image/vnd.adobe.photoshop': ['.psd'],
            'application/postscript': ['.eps'],
            'application/eps': ['.eps'],
            'application/x-eps': ['.eps'],
            'image/eps': ['.eps'],
            'image/x-eps': ['.eps'],
        },
        onDropRejected: rejections => {
            alert(rejections.map(({ errors }) => errors.map(({ message }) => message)).join("\n"))
        },
        onDrop: acceptedFiles => {
            acceptedFiles.forEach(file => {
                addFile(file);
            });
        }
    })
    const addFile = (file) => {
        setFiles(files => {
            return [...files, Object.assign(file, {
                preview: URL.createObjectURL(file)
            })]
        })
        ref.current.push({ file, comment: null })
    }
    const updateComment = (index, comment) => {
        // ref.commentData.push(cmnt)
        if (!ref.current?.[index]) {
            ref.current[index] = {}
        }
        ref.current[index].comment = comment
    }
    const handleDeleteFile = (index) => {
        ref.current.splice(index, 1)
        setReload(!reload)
    }
    // const handleViewFile = () => {
    //     setisOpen(true)
    // }
    const handleViewFile = (file) => {
        const fileType = file.type;
        console.log(fileType);
        var blob = new Blob([file], { type: fileType });
        var blobURL = window.URL.createObjectURL(blob);
        window.open(blobURL);
    }

    return (
        <>

            <div className={styles.files}>
                {ref.current.length > 0 && (
                    ref.current.map(({ file, comment }, index) => {

                        return (
                            <div className={styles.file} key={file.name}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <img
                                        src={getPreview(file)}
                                        // Revoke data uri after image is loaded
                                        onLoad={() => { URL.revokeObjectURL(file.preview) }}
                                        style={{ maxWidth: '100%' }}
                                    />
                                </div>

                                <div style={{ width: '200px', overflow: 'hidden' }}>
                                    <p className="label">{file.name}</p>
                                </div>

                                <div style={{ 'width': '22%' }}>
                                    <TextArea onBlur={(e) => {
                                        updateComment(index, e.target.value)
                                    }} defaultValue={comment} name={index} label="Add a comment" placeholder="type your message here.." />
                                </div>
                                <div style={{ 'width': '27%', display: 'flex', gap: '1em' }}>
                                    <Button onClick={() => { handleDeleteFile(index) }} icon={<DeleteOutlined />} >Delete</Button>
                                    <Button onClick={() => { handleViewFile(file) }} icon={<EyeOutlined />}>View</Button>
                                </div>
                                <Modal onCancel={() => { setisOpen(false) }} open={isModalOpen} footer={<Button onClick={() => { setisOpen(false) }} >Close</Button>}>
                                    <Previewer blob={file} />
                                </Modal>
                            </div>)
                    }
                    )
                )}
            </div>
            <input type="file" {...getInputProps()} style={{ display: "none" }} />
            <div {...getRootProps({ className: styles.dropArea })}>
                <div className={styles.dropIcon}>
                    +
                </div>
                <div className={`button--primary ${styles.uploadButton ?? ''}`}>Add File</div>
            </div>
        </>
    )
})

AddFileUpload.propTypes = {
    inputName: PropTypes.string,
}

export { AddFileUpload };

